var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.59961 13.5339L7.42456 14.6826C9.80528 13.5999 12.2912 11.6412 13.8691 9.51975L13.869 24.6L15.5299 24.6L15.5301 9.51095C17.108 11.6368 19.5939 13.5999 21.9747 14.6826L22.7996 13.5339C18.996 11.8085 15.5301 7.93083 15.5301 5.4L13.8691 5.4C13.8691 7.93083 10.4032 11.8085 6.59961 13.5339Z","fill":"#ADFF00","key":0}),React.createElement("circle",{"cx":"15","cy":"15","r":"14.322","stroke":"#ADFF00","strokeWidth":"1.356","key":1})]);
}

ArrowUp.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
